
<div class="container">
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Devices</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col table-card">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"><a class="btn btn-outline-secondary" [href]="'#/workflow/' + workflowService.workflowConfig.id + '/' + stepName">Back</a></list-controls>
      <table class="table table-responsive">
        <thead>
          <tr class="table-header-with-controls">
            <th>Solution</th>
            <th>Quantity Available</th>
            <th>Quantity Assigned</th>
            <th>Add Assets</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let device of devices">
            <td><span class="badge badge-secondary mr-2" *ngIf="device.quicksilver">QS</span><span>{{ device.friendlyName || device.productDescription }} ({{ device.productNumber }})</span><br><span class="table-cell-sub">{{ device.dartDealId }}.{{ device.dealVersion }}-{{ device.solutionId || 'NA' }}<span [hidden]="!device.preconfigurationServiceNumber"> ({{ device.preconfigurationServiceNumber }})</span></span><span class="text-red table-cell-sub" *ngIf="!device.hasProductsAvailable"><br>This product is unavailable in K2.</span></td>
            <td>{{ device.quantityAvailable >= 0 ? device.quantityAvailable : '' }}</td>
            <td>{{ device.quantityAssigned }}</td>
            <td>
              <button class="btn btn-outline-primary" *ngIf="!device.disabled &amp;&amp; (device.quantityAvailable &gt; 0 || device.enableCatalogPricing) &amp;&amp; device.hasProductsAvailable" (click)="add(device)"><span class="oi oi-plus"></span> Add</button><span class="text-danger font-italic" *ngIf="!device.enableCatalogPricing &amp;&amp; device.quantityAvailable &lt;= 0">Not Available</span><span class="text-danger font-italic" *ngIf="device.disabled &amp;&amp; (device.quantityAvailable &gt; 0 || device.enableCatalogPricing)">Disabled</span>
            </td>
          </tr>
          <tr *ngIf="devices.length === 0">
            <td colspan="6">
              <p class="text-center empty-table-message">There are no devices to display.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>